import './dream-theme.css'; // shared --dg-* tokens; master in dream-home/theme
import './app.css';
import './components.css';
import { mount } from 'svelte';
import App from './App.svelte';
import { font } from './lib/stores';

// Apply the persisted font choice before paint. The record loads reactively on
// Google sign-in (see lib/stores authUser subscription) — no demo seed.
font.subscribe(() => {})();

const app = mount(App, { target: document.getElementById('app')! });

export default app;
